import { render, staticRenderFns } from "./ShaimBalikNaPostu.vue?vue&type=template&id=1c25a3ab&scoped=true&"
import script from "./ShaimBalikNaPostu.vue?vue&type=script&lang=js&"
export * from "./ShaimBalikNaPostu.vue?vue&type=script&lang=js&"
import style0 from "./ShaimBalikNaPostu.vue?vue&type=style&index=0&id=1c25a3ab&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c25a3ab",
  null
  
)

export default component.exports